var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column gr-4",
      attrs: { "data-qa": "club_price_details" },
    },
    [
      _c("div", { staticClass: "d-flex justify-space-between" }, [
        _c("span", { staticClass: "text-body-1 text-secondary--text" }, [
          _vm._v("\n      Обычная цена\n    "),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "text-body-1 text--text",
            attrs: { "data-qa": "club_price_details_full_price" },
          },
          [_vm._v("\n      " + _vm._s(_setup.priceList.full) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _vm.isNoCard
        ? _c("div", { staticClass: "d-flex justify-space-between" }, [
            _vm._m(0),
            _vm._v(" "),
            _setup.priceList.card
              ? _c(
                  "span",
                  {
                    staticClass: "text-body-1 text--text",
                    attrs: { "data-qa": "club_price_details_card_price" },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_setup.priceList.card) + "\n    "
                    ),
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass: "d-flex align-center gc-1",
                    attrs: { "data-qa": "club_price_details_price_card_free" },
                  },
                  [
                    _c("div", { staticClass: "text-body-1 text--text" }, [
                      _vm._v("\n        в подарок\n      "),
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      attrs: {
                        src: "/static/_v1/pd/icons/emoji/wrapped-present.png",
                        width: "20",
                        height: "20",
                        alt: "Подарок",
                        "data-qa": "club_discount_card_free_icon",
                      },
                    }),
                  ]
                ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-space-between mb-3" }, [
        _c("span", { staticClass: "text-body-1 text-secondary--text" }, [
          _vm._v("\n      Скидка клуба\n    "),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "text-body-1 text-error--text",
            attrs: { "data-qa": "club_price_details_club_discount_price" },
          },
          [
            _vm._v(
              "\n      -" + _vm._s(_setup.priceList.clubDiscount) + "\n    "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-h6 text--text d-flex justify-space-between" },
        [
          _vm._v("\n    Итого\n    "),
          _c(
            "span",
            { attrs: { "data-qa": "club_price_details_total_price" } },
            [_vm._v("\n      " + _vm._s(_setup.priceList.total) + "\n    ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c("span", { staticClass: "text-body-1 text-secondary--text" }, [
        _vm._v("\n        Доступ к клубу\n      "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-body-2 text-info--text" }, [
        _vm._v("\n        6 месяцев\n      "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }